import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import { toast } from 'react-toastify';
import ModalUpdateSinger from './components/ModalUpdateSinger';

export default class SingerManagerPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            artists: [],
            selectedArtist: null,
            loading: false
        };
        this.getAllArtists = this.getAllArtists.bind(this);
        this.handleDeleteArtist = this.handleDeleteArtist.bind(this);
    }

    componentDidMount() {
        this.getAllArtists();
    }

    getAllArtists() {
        this.setState({ loading: true });
        
        const url = `${global.config.apiDomain}/yt-song/web/artist`;
        
        axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                // Xử lý nhiều format response khác nhau
                let artistsData = [];
                
                // Format: { status: "OK", data: { artists: [...] } }
                if (res.data && res.data.data && Array.isArray(res.data.data.artists)) {
                    artistsData = res.data.data.artists;
                }
                // Kiểm tra nếu res.data là array trực tiếp
                else if (Array.isArray(res.data)) {
                    artistsData = res.data;
                } 
                // Kiểm tra res.data.data (nếu là array)
                else if (res.data && Array.isArray(res.data.data)) {
                    artistsData = res.data.data;
                } 
                // Kiểm tra res.data.artists
                else if (res.data && Array.isArray(res.data.artists)) {
                    artistsData = res.data.artists;
                } 
                // Kiểm tra res.data với status OK và data.artists
                else if (res.data && res.data.status === 'OK' && res.data.data && Array.isArray(res.data.data.artists)) {
                    artistsData = res.data.data.artists;
                }
                // Kiểm tra res.data với status OK và data là array
                else if (res.data && res.data.status === 'OK' && Array.isArray(res.data.data)) {
                    artistsData = res.data.data;
                } 
                // Kiểm tra res.data với status OK và artists
                else if (res.data && res.data.status === 'OK' && Array.isArray(res.data.artists)) {
                    artistsData = res.data.artists;
                } 
                // Kiểm tra res.data.content (Spring Boot thường dùng)
                else if (res.data && Array.isArray(res.data.content)) {
                    artistsData = res.data.content;
                }
                // Nếu không match format nào, thử tìm array trong object
                else if (res.data && typeof res.data === 'object') {
                    const findArray = (obj) => {
                        for (let key in obj) {
                            if (Array.isArray(obj[key])) {
                                return obj[key];
                            } else if (obj[key] && typeof obj[key] === 'object') {
                                const found = findArray(obj[key]);
                                if (found) return found;
                            }
                        }
                        return null;
                    };
                    const foundArray = findArray(res.data);
                    if (foundArray) {
                        artistsData = foundArray;
                    }
                }
                
                this.setState({
                    artists: artistsData,
                    loading: false
                });
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || error.message || 'Không thể tải danh sách ca sĩ';
                toast.error(errorMessage);
                this.setState({ 
                    artists: [],
                    loading: false 
                });
            });
    }

    handleDeleteArtist(artistId) {
        if (!window.confirm('Bạn có chắc chắn muốn xóa ca sĩ này?')) {
            return;
        }

        const url = `${global.config.apiDomain}/yt-song/web/artist/${artistId}`;
        
        axios.delete(url)
            .then(res => {
                toast.success('Xóa ca sĩ thành công');
                this.getAllArtists();
            })
            .catch(error => {
                toast.error('Không thể xóa ca sĩ');
            });
    }

    render() {
        const { artists, selectedArtist, loading } = this.state;

        try {
            return (
                <>
                    <ModalUpdateSinger 
                        artist={selectedArtist} 
                        onSuccess={this.getAllArtists}
                    />
                    <div id="content">
                    <div className="container-fluid" style={{ marginTop: '20px', padding: '20px' }}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h1 className="mb-0">Quản lý ca sĩ</h1>
                            <button 
                                className="btn btn-primary"
                                data-toggle="modal"
                                data-target="#ModalUpdateSinger"
                                onClick={() => {
                                    this.setState({ selectedArtist: null });
                                }}
                            >
                                <i className="fa-solid fa-plus mr-2"></i>
                                Thêm ca sĩ mới
                            </button>
                        </div>
                        <hr />
                        
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Đang tải...</span>
                                </div>
                                <p className="mt-2 text-muted">Đang tải danh sách ca sĩ...</p>
                            </div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col" style={{ width: '60px', backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>STT</th>
                                            <th scope="col" style={{ width: '100px', backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>Avatar</th>
                                            <th scope="col" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>Tên ca sĩ</th>
                                            <th scope="col" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>Mô tả</th>
                                            <th scope="col" style={{ width: '100px', backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>Type</th>
                                            <th scope="col" style={{ width: '100px', backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>Số bài hát</th>
                                            <th scope="col" style={{ width: '200px', backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!artists || artists.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" className="text-center py-4">
                                                    <p className="text-muted mb-0">Chưa có ca sĩ nào</p>
                                                </td>
                                            </tr>
                                        ) : (
                                            artists.map((artist, index) => (
                                                <tr key={artist.id || index}>
                                                    <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>{index + 1}</td>
                                                    <td className="align-middle" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>
                                                        {artist.avatarUrl ? (
                                                            <img 
                                                                src={artist.avatarUrl} 
                                                                alt={artist.name}
                                                                style={{ 
                                                                    width: '60px', 
                                                                    height: '60px', 
                                                                    objectFit: 'cover',
                                                                    borderRadius: '50%'
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.src = 'https://via.placeholder.com/60?text=No+Image';
                                                                }}
                                                            />
                                                        ) : (
                                                            <div 
                                                                style={{ 
                                                                    width: '60px', 
                                                                    height: '60px', 
                                                                    borderRadius: '50%',
                                                                    backgroundColor: '#dee2e6',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                            >
                                                                <i className="fa-solid fa-user text-muted"></i>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>
                                                        <strong>{artist.name || 'N/A'}</strong>
                                                    </td>
                                                    <td className="align-middle" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>
                                                        <span 
                                                            style={{ 
                                                                display: 'block',
                                                                maxWidth: '300px',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                            title={artist.description}
                                                        >
                                                            {artist.description || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>
                                                        <span className="badge badge-info">
                                                            {artist.type === 1 ? 'Ca sĩ' : artist.type === 2 ? 'Giáo viên' : artist.type || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td className="align-middle" style={{ backgroundColor: '#e9ecef', textAlign: 'left', padding: '12px' }}>
                                                        <span className="badge badge-secondary">{artist.songCount || 0}</span>
                                                    </td>
                                                    <td className="align-middle" style={{ backgroundColor: '#f8f9fa', textAlign: 'left', padding: '12px' }}>
                                                        <button 
                                                            className="btn btn-sm btn-info mr-2"
                                                            data-toggle="modal"
                                                            data-target="#ModalUpdateSinger"
                                                            onClick={() => {
                                                                this.setState({ selectedArtist: artist });
                                                            }}
                                                        >
                                                            <i className="fa-solid fa-edit mr-1"></i>
                                                            Sửa
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => this.handleDeleteArtist(artist.id)}
                                                        >
                                                            <i className="fa-solid fa-trash mr-1"></i>
                                                            Xóa
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </>
            );
        } catch (error) {
            return (
                <div id="content">
                    <div className="container-fluid" style={{ marginTop: '20px', padding: '20px' }}>
                        <h1>Quản lý ca sĩ</h1>
                        <div className="alert alert-danger">
                            <strong>Lỗi:</strong> {error.message}
                        </div>
                    </div>
                </div>
            );
        }
    }
}

